import { Button } from '@iwoca/orion';

import { UnavailableLimit } from './UnavailableLimit';
import { daysSinceStatusDate } from '../../../Dashboard.helpers';
import { Application } from '../../../Dashboard.types';
import {
  SpendingLimitEntry,
  TSpendingLimitType,
} from '../../../hooks/useGetSpendingLimits';

const ALL_LIMIT_TYPES: TSpendingLimitType[] = ['THREE_MONTHS', 'TWELVE_MONTHS'];

export const DeclinedLimitDrawer = ({
  refreshSpendingLimit,
  loadingRefreshSpendingLimit,
  errorMessage,
  application,
}: {
  spendingLimits: { isValid: boolean; limits: SpendingLimitEntry[] };
  refreshSpendingLimit: () => Promise<void>;
  loadingRefreshSpendingLimit: boolean;
  errorMessage: string | null;
  application: Application;
}) => {
  const daysSinceDecline = daysSinceStatusDate(application);

  // Don't let them refresh until 30 days after decline.
  // If we don't know how many days since decline, let them try
  const showRefreshButton =
    daysSinceDecline !== null ? daysSinceDecline >= 30 : true;

  return (
    <>
      <div className="mb-xl flex flex-col gap-xl">
        {ALL_LIMIT_TYPES.map((limitType) => {
          return <UnavailableLimit sellerProduct={limitType} key={limitType} />;
        })}
        {showRefreshButton && (
          <div>
            <Button
              disabled={loadingRefreshSpendingLimit}
              onClick={refreshSpendingLimit}
              className="w-full"
            >
              {loadingRefreshSpendingLimit ? (
                <>
                  <svg
                    className="h-l w-l animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                  </svg>
                  Checking limits...
                </>
              ) : (
                <>Secure my limits</>
              )}
            </Button>
            {errorMessage && (
              <div className="mt-2xs text-center text-error">
                {errorMessage}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
